import { create } from "zustand";

export enum OrgRegistrationStepEnum {
  orgInfoForm = "ORG_INFO_FORM",
  selectVerificationMethod = "SELECT_VERIFICATION_METHOD",
  verifyWithEmail = "VERIFY_WITH_EMAIL",
  verifyWithDomainTxtRecord = "VERIFY_WITH_DOMAIN_TXT_RECORD",
  verifyWithUploadFileToHost = "VERIFY_WITH_UPLOAD_FILE_TO_HOST",
  verifyWithUploadCertificate = "VERIFY_WITH_UPLOAD_CERTIFICATE",
}

interface IOrganizationProfileStoreState {
  orgRegistrationStep: OrgRegistrationStepEnum;
}

interface IOrganizationProfileStoreAction {
  setOrgRegistrationStep: (orgRegistrationStep?: OrgRegistrationStepEnum) => void;
}

type TOrganizationProfileStore = IOrganizationProfileStoreAction & IOrganizationProfileStoreState;

const initialState: IOrganizationProfileStoreState = {
  orgRegistrationStep: OrgRegistrationStepEnum.orgInfoForm,
};

export const useOrganizationProfileStore = create<TOrganizationProfileStore>((set) => ({
  ...initialState,
  setOrgRegistrationStep: (orgRegistrationStep) => {
    set(() => ({ orgRegistrationStep }));
  },
}));
